const Logan = Mach.requireModule('Logan');
const Raptor = Mach.requireModule('Raptor');
const defaultTags = {
  container: 'Mach Pro',
  osName: Mach.env.osName ?? '',
  osVersion: Mach.env.osVersion ?? '',
  appVersion: Mach.env.version ?? '',
  platform: Mach.env.isAndroid ? 'Android' : 'iOS',
};
function logan(logData) {
  if (Logan) {
    try {
      const logStr = JSON.stringify(logData);
      if (logStr) {
        Logan.log(logStr);
      }
    } catch (error) {}
  }
}

function reportMetrics(val, customTags = {}, sampleRate = 1) {
  const tags = { ...defaultTags, ...customTags };
  Raptor?.reportMetrics(val, tags, sampleRate);
}

export { logan, reportMetrics };
